import BrokenImageIcon from '@mui/icons-material/BrokenImage'
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation'
import DownloadIcon from '@mui/icons-material/Download'
import SearchIcon from '@mui/icons-material/Search'
import {Backdrop, Menu, MenuItem, Modal} from '@mui/material'
import Box from '@mui/material/Box'
import {yMarker} from 'assets/imageDeclear'
import dayjs from 'dayjs'
import {envBackHost, envImagePath, serverLocalName} from 'GLOBAL/envVariables'
import {axiosWithAuth} from 'helper/axiosWithAuth'
import fileDownload from 'js-file-download'
import {PhotoInfoCardComponent} from 'pages/customer/simpleComponent/photoInfoComponent'
import {useEffect, useRef, useState} from 'react'
import {useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import {globalFormatWithHyphens, globalSerialNumberFormatWithHyphens} from 'utils/const/globalConst'
import {outerInstallShowHandler, showBusanInfoHandler} from 'utils/const/globalController'
import {firstDataAlert, lastDataAlert, noFindDataAlert, resultAlert} from 'utils/CustomAlert/Alert'
import useMobileBackClose from 'utils/hooks/useMobileBackClose'
import './print.css'
type PhotoInfoItem = {
  label: string
  value: string
  id: string
}

const PhotoModal = (props: any) => {
  /*********************************************************************
   * 1. Init Libs
   *********************************************************************/

  const {
    setData,
    data,
    open,
    onClose,
    page = 'defalut',
    rowCount = 1,
    pagenation = 1,
    perPage = 30,
    getList,
    filter,
    count,
  } = props
  useMobileBackClose(open, onClose)
  const [photoCustomerData, setPhotoCustomerData] = useState<any>({})
  const keyLockRef = useRef(false)
  const officeInfo = useSelector((state: any) => state?.officeInfo)
  const cooperInfo = useSelector((state: any) => state?.cooperInfo)
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    height: '95%',
    bgcolor: 'background.paper',
    overflowY: 'auto',
    borderRadius: '12px',
    boxShadow: 24,
    p: 3,
  }

  const filterInit = {
    searchOption: {
      customerNumber: false,
      customerName: false,
      address: false,
      managerName: false,
      memo: false,
      serialNumber: false,
      installerName: false,
    },
    searchData: '',
    deviceStatus: 'all',
    efosStatus: 'all',
    freezeWarningType: 'all',
    recognizedType: 'all',
    deviceType: 'all',
    batteryStatus: 'all',
    serverCycle: 'all',
    rowPerPage: 300,
    page: 1,
  }

  const photoList = [
    ...(page === 'info'
      ? [
          {
            label: '설치서명',
            url: photoCustomerData?.installSignPhoto,
            id: 'INSTALL_SIGN_PHOTO',
            check: false,
          },
        ]
      : []),
    {
      label: '설치환경',
      url: photoCustomerData?.installEnvPhoto,
      id: 'INSTALL_ENV_PHOTO',
      check: true,
    },
    {
      label: '계량기',
      url: photoCustomerData?.installMeterReadPhoto,
      id: 'INSTALL_METER_READ_PHOTO',
      check: true,
    },
    {
      label: '통신선',
      url: photoCustomerData?.installCommLinePhoto,
      id: 'INSTALL_COMM_LINE_PHOTO',
      check: true,
    },
    {
      label: '검침기',
      url: photoCustomerData?.installCameraPhoto,
      id: 'INSTALL_CAMERA_PHOTO',
      check: true,
    },
    {
      label: '단말기',
      url: photoCustomerData?.installOutletBoxPhoto,
      id: 'INSTALL_OUTLET_BOX_PHOTO',
      check: true,
    },
    {label: '설치영상', url: photoCustomerData?.installPhoto, id: 'INSTALL_PHOTO', check: false},
    {
      label: '기타1',
      url: photoCustomerData?.installExtraPhoto,
      id: 'INSTALL_EXTRA_PHOTO_WIDE',
      check: true,
    },
    {
      label: '기타2',
      url: photoCustomerData?.installWrongPhoto,
      id: 'INSTALL_EXTRA_PHOTO',
      check: false,
    },
  ]

  const photoCustomerInfo: PhotoInfoItem[] = [
    {
      label: '수용가 번호',
      value: photoCustomerData?.customerNumber
        ? globalFormatWithHyphens(officeInfo?.value, photoCustomerData?.customerNumber)
        : '-',
      id: 'customerNumber',
    },
    {
      label: '수용가명',
      value: photoCustomerData?.customerName || '-',
      id: 'customerName',
    },
    {
      label: '수용가 전화번호',
      value: photoCustomerData?.phoneNumber || '-',
      id: 'phoneNumber',
    },
    {
      label: '주소(도로명)',
      value: photoCustomerData?.addressRoad || '-',
      id: 'addressRoad',
    },
    {
      label: '주소(지번)',
      value: photoCustomerData?.addressNumber || '-',
      id: 'addressNumber',
    },
    {
      label: '상세 주소',
      value: photoCustomerData?.addressDetail || '-',
      id: 'addressDetail',
    },
    {
      label: '담당자',
      value: photoCustomerData?.managerName || '-',
      id: 'managerName',
    },
    {
      label: '담당자 전화번호',
      value: photoCustomerData?.managerPhoneNumber || '-',
      id: 'managerPhoneNumber',
      // id: 'filter2',
    },
    {
      label: '메모',
      value: photoCustomerData?.memo || '=',
      id: 'memo',
    },
  ]

  const photoInstallInfo: PhotoInfoItem[] = [
    {
      label: '검침영상외부표시장치',
      value: photoCustomerData?.isExternalDisplayInstalled,
      id: 'isExternalDisplayInstalled',
    },
    {
      label: '외함',
      value: photoCustomerData?.isOuterCaseInstalled,
      id: 'isOuterCaseInstalled',
    },
    {
      label: '외함 사이즈',
      value:
        (photoCustomerData?.isOuterCaseInstalled && photoCustomerData?.outerCaseSizeType) || '-',
      id: 'outerCaseSizeType',
    },
  ]

  const photoInstallOptionsMap: Record<string, {label: string; value: any}[]> = {
    isOuterCaseInstalled: [
      {label: '-', value: null},
      {label: 'O', value: true},
      {label: 'X', value: false},
    ],
    outerCaseSizeType: [
      {label: '-', value: null},
      {label: '소', value: '소'},
      {label: '대', value: '대'},
    ],
    isExternalDisplayInstalled: [
      {label: '-', value: null},
      {label: 'O', value: true},
      {label: 'X', value: false},
    ],
  }

  const photoMeterInfo: PhotoInfoItem[] = [
    {
      label: '계량기 제조회사',
      value: photoCustomerData?.meterManufacturer || '-',
      id: 'meterManufacturer',
    },
    {
      label: '계량기 번호',
      value: photoCustomerData?.meterNumber || '-',
      id: 'meterNumber',
    },
    {
      label: '구경',
      value: photoCustomerData?.meterDiameter || '-',
      id: 'meterDiameter',
    },
  ]

  const photoCheckInfo: PhotoInfoItem[] = [
    {
      label: '검침월',
      value: photoCustomerData?.checkMonth || '-',
      id: 'checkMonth',
    },
    {
      label: '검침일',
      value: photoCustomerData?.checkDay || '-',
      id: 'checkDay',
    },
  ]

  const photoMeterReadInfo: PhotoInfoItem[] = [
    {
      label: '단말기 제조회사',
      value: photoCustomerData?.cooperName ? photoCustomerData?.cooperName : '-',
      id: 'cooperName',
    },
    {
      label: photoCustomerData?.cooperIdx === 1 ? 'IOT이미지검침단말기 번호' : '원격단말기 번호',
      value:
        photoCustomerData?.serialNumber && photoCustomerData.serialNumber !== 'NULL'
          ? globalSerialNumberFormatWithHyphens(photoCustomerData.serialNumber)
          : '-',
      id: 'serialNumber',
    },
    {
      label: '검침영상플레이어 번호',
      value:
        photoCustomerData?.meterReadSerialNumber &&
        photoCustomerData.meterReadSerialNumber !== 'NULL'
          ? globalSerialNumberFormatWithHyphens(photoCustomerData?.meterReadSerialNumber)
          : '-',
      id: 'meterReadSerialNumber',
    },
    {
      label: '설치 일자',
      value: photoCustomerData?.installAt
        ? dayjs(photoCustomerData?.installAt).format('YYYY년 MM월 DD일 HH시')
        : '-',
      id: 'installAt',
    },
  ]

  const thumbnailRefs = useRef<(HTMLDivElement | null)[]>([])
  /*********************************************************************
   * 2. State settings
   *********************************************************************/

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const buttonOpen = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  //rn
  const [customerIndex, setCustomerIndex] = useState<number>(0)
  const [selectedIndex, setSelectedIndex] = useState<number>(0)
  const [selectedPhotoType, setSelectedPhotoType] = useState<any>([])
  const [innerFilter, setInnerFilter] = useState<any>(filterInit)
  const [totalCount, setTotalCount] = useState<any>(null)
  const [officeTotalCount, setOfficeTotalCount] = useState<any>(null)
  const [innerCustomerList, setInnerCustomerList] = useState<any>([])
  const [selectedCustomerId, setSelectedCustomerId] = useState<string | null>(null)
  const [innerLoading, setInnerLoading] = useState<boolean>(false)
  const [isZoomOpen, setIsZoomOpen] = useState(false)
  /**
   * 1. 검색어 아무것도 입력 안한 상태 (전체) 에서 모달 들어온 경우 => default
   * 2. 검색어 입력 후 들어온 경우 (선택) => externalSearch
   * 3. 내부에서 검색 후 여러개가 나온 경우 => internalSearch
   * 4. 내부에서 검색 했는데 단 1개만 나온 경우 => innerDefault
   */
  const [prevNextStep, setPrevNextStep] = useState<any>(null)

  if (open) {
    console.log(
      'officeId',
      officeInfo.value,
      'officeTotalCount',
      officeTotalCount,
      'totalCount',
      totalCount,
      'idx',
      customerIndex,
      'mode',
      prevNextStep,
      'inner',
      selectedCustomerId,
      'data',
      photoCustomerData,
      'page',
      page
    )
  }
  /*********************************************************************
   * 3. Handlers
   *********************************************************************/
  const reset = () => {
    setSelectedPhotoType([])
    setSelectedIndex(0)
    setTotalCount(null)
    setCustomerIndex(0)
    setOfficeTotalCount(null)
    setIsZoomOpen(false)
  }

  const closeHandler = () => {
    setData({})
    setInnerFilter(filterInit)
    setInnerCustomerList([])
    setSelectedCustomerId(null)
    reset()
    onClose()
  }

  const customerCallInit = async (officeInfo: any, cooperInfo: any) => {
    const officeID = String(officeInfo.value).slice(0, 2)
    const res = await axiosWithAuth().get(
      `${envBackHost}/${officeInfo?.value === 'yit' ? 'all' : officeInfo?.value}/${
        cooperInfo?.value
      }/customer/${officeID === '13' && page === 'status' ? 'overview' : 'info'}`,
      {
        params: filterInit,
      }
    )
    if (res.data) {
      setOfficeTotalCount(res.data.count)
    }
  }

  const getPhotoDownload = async (types: any, selectedPhoto: any) => {
    const installPhotoParams = selectedPhoto.join(',')
    const officeID = String(officeInfo.value).slice(0, 2)
    const status = officeID === '13' && page === 'status' ? 'OVERVIEW' : 'INFO'

    switch (types) {
      case 'excel':
        await toast
          .promise(
            axiosWithAuth()
              .get(
                `${envBackHost}/customer/excel/photo/${officeInfo?.value}/${photoCustomerData?.customerNumber}?installPhotos=${installPhotoParams}&status=${status}`,
                {
                  responseType: 'blob',
                }
              )
              .then(async (res) => {
                await resultAlert({resultCode: 0})
                fileDownload(
                  res.data,
                  `${officeInfo?.label}_${
                    officeID === '13'
                      ? photoCustomerData?.customerNumber
                      : photoCustomerData?.customerName
                  }_사진첩.xlsx`
                )
              })
              .catch(async (e) => {
                await resultAlert({resultCode: 400})
              }),
            {
              pending: '다운로드 중입니다.',
            },
            {
              position: 'top-center',
              autoClose: 1000,
              className: 'fs-3  fw-bold',
              style: {width: '400px'},
            }
          )
          .catch(async (e) => {
            console.log(e)
            await resultAlert({resultCode: 400})
          })
        break
      case 'pdf':
        await toast
          .promise(
            axiosWithAuth()
              .get(
                `${envBackHost}/customer/pdf/photo/${officeInfo?.value}/${photoCustomerData?.customerNumber}?installPhotos=${installPhotoParams}&status=${status}`,
                {
                  responseType: 'blob',
                }
              )
              .then(async (res) => {
                await resultAlert({resultCode: 0})
                fileDownload(
                  res.data,
                  `${officeInfo?.label}_${
                    officeID === '13'
                      ? photoCustomerData?.customerNumber
                      : photoCustomerData?.customerName
                  }_사진첩.pdf`
                )
              })
              .catch(async (e) => {
                await resultAlert({resultCode: 400})
              }),
            {
              pending: '다운로드 중입니다.',
            },
            {
              position: 'top-center',
              autoClose: 1000,
              className: 'fs-3  fw-bold',
              style: {width: '400px'},
            }
          )
          .catch(async (e) => {
            console.log(e)
            await resultAlert({resultCode: 400})
          })
        break

      default:
        return null
    }
  }

  const customerSearchCall = async (officeInfo: any, cooperInfo: any, filter: any) => {
    setInnerLoading(true)
    const officeID = String(officeInfo.value).slice(0, 2)

    try {
      const hasSearchData = filter.searchData && filter.searchData.trim() !== ''
      const hasAnySearchOption =
        filter.searchOption && Object.values(filter.searchOption).some((v: any) => v === true)

      let finalSearchOption = filter.searchOption
      if (hasSearchData && !hasAnySearchOption) {
        finalSearchOption = {
          customerNumber: true,
          customerName: officeID === '13' && page === 'status' ? false : true,
          address: officeID === '13' && page === 'status' ? false : true,
          managerName: officeID === '13' && page === 'status' ? false : true,
          memo: officeID === '13' && page === 'status' ? false : true,
          serialNumber: true,
          installerName: officeID === '13' && page === 'status' ? false : true,
        }
      }

      let filtered = {
        ...filter,
        searchOption: finalSearchOption,
        searchData: filter.searchData.replace(/-/g, ''),
      }

      const apiEndpoint = officeID === '13' && page === 'status' ? 'overview' : 'overview'

      const res = await axiosWithAuth().get(
        `${envBackHost}/${officeInfo?.value === 'yit' ? 'all' : officeInfo?.value}/${
          cooperInfo?.value
        }/customer/${apiEndpoint}`,
        {
          params: filtered,
        }
      )

      const firstCustomer = res?.data?.res?.[0]

      if (!firstCustomer) {
        setInnerLoading(false)
        noFindDataAlert()
        return
      }

      if (res.data.count === 1) {
        setPrevNextStep('innerDefault')

        const rnRes = await axiosWithAuth().get(
          `${envBackHost}/rn?officeId=${
            officeInfo?.value === 'yit' ? 'all' : officeInfo?.value
          }&customerNumber=${firstCustomer.customerNumber}`
        )

        setCustomerIndex(rnRes.data.res)
      } else {
        setPrevNextStep('internalSearch')
        setCustomerIndex(1)
      }

      setTotalCount(res.data.count)
      setSelectedCustomerId(firstCustomer?.customerNumber)
      setInnerCustomerList(res.data.res)
      setPhotoCustomerData(firstCustomer)
      setInnerLoading(false)
    } catch (error) {
      setInnerLoading(false)
      await resultAlert({resultCode: 400})
    }
  }

  const chooseFilterHandler = (type: any) => {
    switch (type) {
      case 'default':
      case 'externalSearch':
        return filter
      case 'internalSearch':
        return innerFilter
      case 'innerDefault':
        return filterInit
      default:
        return filter
    }
  }

  const prevNextCustomerNumberCall = async (
    officeInfo: any,
    cooperInfo: any,
    mode: any,
    button: any
  ) => {
    const officeID = String(officeInfo.value).slice(0, 2)

    try {
      let idx = customerIndex

      if (button === 'prev') {
        idx = idx - 1
      }
      if (button === 'next') {
        idx = idx + 1
      }

      let maxCount: number
      if (mode === 'innerDefault') {
        maxCount = officeTotalCount
      } else if (mode === 'internalSearch') {
        maxCount = totalCount
      } else {
        maxCount = count
      }

      if (idx <= 0) {
        firstDataAlert()
        return
      }

      if (idx > maxCount) {
        lastDataAlert()
        return
      }

      setSelectedIndex(0)
      setCustomerIndex(idx)

      let selectedFilter = chooseFilterHandler(mode)
      let targetCustomer

      if (mode === 'externalSearch') {
        // 검색 필드 추출
        const searchFields = [
          'customerName',
          'customerNumber',
          'address',
          'serialNumber',
          'managerName',
          'memo',
          'installerName',
        ]
        const activeSearchFields: Record<string, string> = {}

        searchFields.forEach((field) => {
          if (selectedFilter[field] && selectedFilter[field] !== '') {
            activeSearchFields[field] = selectedFilter[field]
          }
        })

        const hasActiveSearchFields = Object.keys(activeSearchFields).length > 0

        const filterKeys = [
          'deviceStatus',
          'efosStatus',
          'freezeWarningType',
          'recognizedType',
          'deviceType',
          'batteryStatus',
          'signalStrength',
          'temperature',
          'customerStatus',
          'isRevised',
          'processStatus',
          'startDate',
          'endDate',
          'diameters',
        ]

        let processedFilter: any
        let apiEndpoint: string

        if (hasActiveSearchFields) {
          // 개별 필드 검색 방식 (customerName, customerNumber 등이 직접 설정된 경우)
          processedFilter = {
            ...filterKeys.reduce((acc, key) => {
              acc[key] = selectedFilter?.[key]
              return acc
            }, {} as Record<string, any>),
            ...activeSearchFields,
            rowPerPage: count,
            page: 1,
          }
          apiEndpoint = officeID === '13' && page === 'status' ? 'overview' : 'info'
        } else {
          // searchOption + searchData 방식
          const hasSearchData = selectedFilter.searchData && selectedFilter.searchData.trim() !== ''
          const hasAnySearchOption =
            selectedFilter.searchOption &&
            Object.values(selectedFilter.searchOption).some((v: any) => v === true)

          let finalSearchOption = selectedFilter.searchOption
          if (hasSearchData && !hasAnySearchOption) {
            // searchData는 있는데 searchOption이 모두 false인 경우 자동 설정
            finalSearchOption = {
              customerNumber: true,
              customerName: officeID === '13' && page === 'status' ? false : true,
              address: officeID === '13' && page === 'status' ? false : true,
              managerName: officeID === '13' && page === 'status' ? false : true,
              memo: officeID === '13' && page === 'status' ? false : true,
              serialNumber: true,
              installerName: officeID === '13' && page === 'status' ? false : true,
            }
          }

          processedFilter = {
            ...selectedFilter,
            searchOption: finalSearchOption,
            searchData: (selectedFilter.searchData || '').replace(/-/g, ''),
            rowPerPage: count,
            page: 1,
          }

          apiEndpoint = 'overview'
        }

        const res = await axiosWithAuth().get(
          `${envBackHost}/${officeInfo?.value === 'yit' ? 'all' : officeInfo?.value}/${
            cooperInfo?.value
          }/customer/${apiEndpoint}`,
          {
            params: processedFilter,
          }
        )

        targetCustomer = res?.data?.res?.[idx - 1]
      } else if (mode === 'internalSearch') {
        targetCustomer = innerCustomerList[idx - 1]
      } else {
        let controlledFilters = {
          ...selectedFilter,
          rowPerPage: 1,
          page: idx,
        }

        const apiEndpoint = officeID === '13' && page === 'status' ? 'overview' : 'info'

        const res = await axiosWithAuth().get(
          `${envBackHost}/${officeInfo?.value === 'yit' ? 'all' : officeInfo?.value}/${
            cooperInfo?.value
          }/customer/${apiEndpoint}`,
          {
            params: controlledFilters,
          }
        )

        targetCustomer = res?.data?.res?.[0]
      }

      if (!targetCustomer) {
        noFindDataAlert()
        return
      }

      if (mode === 'innerDefault') {
        setPrevNextStep('default')
      }

      setSelectedCustomerId(targetCustomer?.customerNumber)
      setPhotoCustomerData(targetCustomer)
    } catch (error) {
      await resultAlert({resultCode: 400})
    }
  }
  /*********************************************************************
   * 4. UseEffect
   *********************************************************************/

  useEffect(() => {
    setPhotoCustomerData(data)
  }, [data])

  /**
   * 열었을때 검색 했는지 안했는지 여부 확인
   */
  useEffect(() => {
    if (open) {
      customerCallInit(officeInfo, cooperInfo)

      // ← 검색 여부를 판단하는 로직 개선
      const isSearched = () => {
        // searchData가 있으면 무조건 검색한 것
        if (filter.searchData && filter.searchData.trim() !== '') {
          return true
        }

        // searchOption 중 하나라도 true면 검색 의도가 있는 것
        if (filter.searchOption) {
          const hasSearchOption = Object.values(filter.searchOption).some((v) => v === true)
          if (hasSearchOption) {
            return true
          }
        }

        // 필터 옵션들이 'all'이 아닌 값으로 설정되어 있으면 검색한 것
        const filterOptions = [
          'deviceStatus',
          'efosStatus',
          'freezeWarningType',
          'recognizedType',
          'deviceType',
          'batteryStatus',
          'serverCycle',
        ]

        const hasFilterOption = filterOptions.some((key) => {
          return filter[key] && filter[key] !== 'all'
        })

        if (hasFilterOption) {
          return true
        }

        return false
      }

      if (isSearched()) {
        setPrevNextStep('externalSearch')
        setCustomerIndex(data.rn)
      } else {
        setPrevNextStep('default')
        setCustomerIndex((pagenation - 1) * perPage + rowCount)
      }

      setTotalCount(count)
    }
  }, [open])
  /**
   * 위경도 변경
   */
  useEffect(() => {
    setTimeout(() => {
      if (!window.kakao?.maps) {
        console.log('[PhotoModal] kakao maps not loaded')
        return
      }
      let container = document?.getElementById('map')
      if (!container) return

      const hasCoords =
        photoCustomerData && photoCustomerData.latitude && photoCustomerData.longitude

      const lat = hasCoords ? photoCustomerData.latitude : 37.5665
      const lng = hasCoords ? photoCustomerData.longitude : 126.978

      const map = new window.kakao.maps.Map(container, {
        center: new window.kakao.maps.LatLng(lat, lng),
        mapTypeId: window.kakao.maps.MapTypeId.HYBRID,
        level: hasCoords ? 1 : 12,
        draggable: false,
        scrollwheel: false,
        zoomable: false,
      })

      const mapTypeControl = new window.kakao.maps.MapTypeControl()
      map.addControl(mapTypeControl, window.kakao.maps.ControlPosition.TOPRIGHT)

      if (hasCoords) {
        const markerPosition = new window.kakao.maps.LatLng(lat, lng)
        const marker = new window.kakao.maps.Marker({
          position: markerPosition,
          image: new window.kakao.maps.MarkerImage(yMarker, new window.kakao.maps.Size(40, 59)),
        })
        marker.setMap(map)
      }
    }, 300)
  }, [photoCustomerData])

  /**
   * 상,하 방향키로 이미지 변경 가능
   */
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (!open) return

      if (e.key === 'ArrowDown') {
        setSelectedIndex((prev) => Math.min(prev + 1, photoList.length - 1))
      }

      if (e.key === 'ArrowUp') {
        setSelectedIndex((prev) => Math.max(prev - 1, 0))
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [open, photoList.length])

  /**
   * 좌,우 방향키로 수용가 변경
   */
  useEffect(() => {
    const handleArrowLeftRight = (e: KeyboardEvent) => {
      if (!open || keyLockRef.current) return

      if (e.key === 'ArrowRight') {
        if (prevNextStep === 'innerDefault' || customerIndex < totalCount) {
          keyLockRef.current = true
          prevNextCustomerNumberCall(officeInfo, cooperInfo, prevNextStep, 'next')
          setTimeout(() => (keyLockRef.current = false), 1000) // 1000ms 쿨타임
        }
      }

      if (e.key === 'ArrowLeft') {
        if (prevNextStep === 'innerDefault' || customerIndex > 1) {
          keyLockRef.current = true
          prevNextCustomerNumberCall(officeInfo, cooperInfo, prevNextStep, 'prev')
          setTimeout(() => (keyLockRef.current = false), 1000) // 1000ms 쿨타임
        }
      }
    }

    window.addEventListener('keydown', handleArrowLeftRight)
    return () => window.removeEventListener('keydown', handleArrowLeftRight)
  }, [open, customerIndex, totalCount, prevNextStep])

  useEffect(() => {
    const currentRef = thumbnailRefs.current[selectedIndex]
    if (currentRef) {
      currentRef.scrollIntoView({behavior: 'smooth', block: 'center'})
    }
  }, [selectedIndex])

  /*********************************************************************
   * 5. Page configuration
   *********************************************************************/
  return (
    <Modal
      open={open}
      onClose={() => {
        closeHandler()
      }}
      closeAfterTransition
      slots={{backdrop: Backdrop}}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      id={'printTarget'}
      className={'printTarget'}
    >
      <>
        <Box sx={style}>
          <div className={'w-100 d-flex justify-content-between'}>
            <div className='flex gap-[1.5rem] mb-2 flex-col lg:flex-row'>
              <div className='flex gap-[1.5rem] items-center'>
                <button
                  type='button'
                  className={`flex items-center px-4 py-0 h-12 text-white font-bold text-sm uppercase rounded-full shadow-md hover:opacity-90 transition ${(() => {
                    if (prevNextStep === 'innerDefault' || prevNextStep === 'default') {
                      return customerIndex > 1
                        ? 'bg-gradient-to-l focus:ring-slate-300 from-blue-500 to-blue-600'
                        : 'bg-slate-600'
                    }
                    return customerIndex > 1
                      ? 'bg-gradient-to-l focus:ring-slate-300 from-blue-500 to-blue-600'
                      : 'bg-slate-600'
                  })()}`}
                  onClick={() => {
                    if (customerIndex > 1) {
                      prevNextCustomerNumberCall(officeInfo, cooperInfo, prevNextStep, 'prev')
                    }
                  }}
                >
                  <span className='mr-2'>←</span>
                  <span>이전 수용가</span>
                </button>
                <button
                  type='button'
                  className={`flex items-center px-4 py-0 h-12 text-white font-bold text-sm uppercase rounded-full shadow-md hover:opacity-90 transition ${(() => {
                    if (prevNextStep === 'innerDefault' || prevNextStep === 'default') {
                      return customerIndex < officeTotalCount
                        ? 'bg-gradient-to-r focus:ring-slate-300 from-blue-500 to-blue-600'
                        : 'bg-slate-600'
                    }

                    return customerIndex < totalCount
                      ? 'bg-gradient-to-r focus:ring-slate-300 from-blue-500 to-blue-600'
                      : 'bg-slate-600'
                  })()}`}
                  onClick={() => {
                    const maxCount =
                      prevNextStep === 'innerDefault' || prevNextStep === 'default'
                        ? officeTotalCount
                        : totalCount

                    if (customerIndex < maxCount) {
                      prevNextCustomerNumberCall(officeInfo, cooperInfo, prevNextStep, 'next')
                    }
                  }}
                >
                  <span>다음 수용가</span>
                  <span className='ml-2'>→</span>
                </button>

                <span className='text-[16px] lg:text-[20px] font-bold'>
                  {photoCustomerData?.customerName} 설치 정보
                </span>
              </div>
              <div className='flex gap-[1.5rem] items-center'>
                <div id='table-header-end'>
                  <button
                    type='button'
                    disabled={!photoCustomerData?.existsInstallPhoto}
                    onClick={handleClick}
                    className={`flex items-center mx-1 px-4 py-0 h-12 text-white font-bold text-sm rounded shadow-md  transition ${
                      photoCustomerData?.existsInstallPhoto
                        ? 'bg-emerald-600 hover:bg-emerald-700'
                        : 'bg-gray-500'
                    }`}
                  >
                    <DownloadIcon className='mr-2' />
                    사진첩 다운로드
                  </button>

                  <Menu anchorEl={anchorEl} open={buttonOpen} onClose={handleClose}>
                    <MenuItem onClick={() => getPhotoDownload('pdf', selectedPhotoType)}>
                      PDF 다운로드
                    </MenuItem>
                    <MenuItem onClick={() => getPhotoDownload('excel', selectedPhotoType)}>
                      엑셀 다운로드
                    </MenuItem>
                  </Menu>
                </div>
                <div className='flex items-stretch border h-12 border-gray-200 rounded-lg overflow-hidden'>
                  <input
                    type='text'
                    placeholder='검색어를 입력해 주세요'
                    value={innerFilter.searchData}
                    onChange={(e: any) => {
                      setInnerFilter((prev: any) => ({...prev, searchData: e.target.value}))
                    }}
                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                      if (
                        e.key === 'ArrowLeft' ||
                        e.key === 'ArrowRight' ||
                        e.key === 'ArrowRight' ||
                        e.key === 'ArrowDown'
                      ) {
                        e.stopPropagation()
                      }
                      if (e.key === 'Enter') {
                        customerSearchCall(officeInfo, cooperInfo, innerFilter)
                      }
                    }}
                    className='px-3 h-full w-[10rem] lg:w-[24rem] text-lg outline-none'
                  />
                  <button
                    onClick={() => customerSearchCall(officeInfo, cooperInfo, innerFilter)}
                    type='button'
                    className='flex items-center justify-center bg-indigo-500 hover:bg-indigo-600 transition text-white px-4 h-full'
                  >
                    <SearchIcon />
                  </button>
                </div>
              </div>

              {innerLoading && <span className='font-semibold text-[1.25rem]'>검색 중입니다.</span>}
              {!innerLoading && innerCustomerList.length > 1 && (
                <select
                  className='text-[1.25rem] font-semibold border border-gray-300 px-2 py-2'
                  value={selectedCustomerId || ''}
                  onChange={(e) => {
                    const selected = innerCustomerList.find(
                      (c: any) => c.customerNumber === e.target.value
                    )
                    setCustomerIndex(e.target.selectedIndex + 1)
                    setSelectedCustomerId(e.target.value)
                    setPhotoCustomerData(selected)
                  }}
                >
                  {innerCustomerList.map((customer: any) => (
                    <option key={customer.rn} value={customer.customerNumber}>
                      {customer.customerName} ({customer.customerNumber})
                    </option>
                  ))}
                </select>
              )}
            </div>
            <CancelPresentationIcon
              sx={{fontSize: '40px', cursor: 'pointer'}}
              color={'error'}
              onClick={() => {
                closeHandler()
              }}
            />
          </div>
          <div className='flex flex-col lg:flex-row gap-6'>
            {/* 수용가 정보*/}

            <div className='basis-full lg:basis-[30%] shrink-0 max-h-[85vh] rounded-lg border bg-blue-100 p-2 overflow-auto'>
              <div
                id='map'
                style={{width: '100%', height: 280}}
                className='rounded-lg border-gray-400 border border-1 mb-2'
                onClick={(e: any) => {
                  const target = e.target as HTMLElement
                  if (target.tagName === 'BUTTON') {
                    const title = target.getAttribute('title')
                    if (title === '지도' || title === '스카이뷰') return
                  }

                  const address = photoCustomerData.addressRoad?.split('/')[0].trim() ?? ''
                  if (showBusanInfoHandler(serverLocalName, officeInfo.value)) {
                    window.open(
                      `https://m.map.kakao.com/scheme/search?q=${address}&center=me`,
                      '_blank'
                    )
                  }
                }}
              />
              {showBusanInfoHandler(serverLocalName, officeInfo.value) && (
                <div className='mb-2 flex justify-end'>
                  <span className='text-red-500 font-semibold'>
                    지도를 클릭하면 카카오맵으로 이동합니다.
                  </span>
                </div>
              )}
              <PhotoInfoCardComponent
                section='customer'
                headTitle='수용가 정보'
                list={photoCustomerInfo}
                fixable={showBusanInfoHandler(serverLocalName, officeInfo.value)}
                originalData={photoCustomerData}
                reCall={getList}
              />

              <PhotoInfoCardComponent
                section='meter'
                headTitle='계량기 정보'
                list={photoMeterInfo}
                fixable={showBusanInfoHandler(serverLocalName, officeInfo.value)}
                originalData={photoCustomerData}
                reCall={getList}
              />
              <PhotoInfoCardComponent
                section='check'
                headTitle='검침일 정보'
                list={photoCheckInfo}
                fixable={showBusanInfoHandler(serverLocalName, officeInfo.value)}
                originalData={photoCustomerData}
                reCall={getList}
              />
              {outerInstallShowHandler(serverLocalName, officeInfo.value) && (
                <PhotoInfoCardComponent
                  section='extraSetting'
                  headTitle='기타 정보'
                  list={photoInstallInfo}
                  fixable={showBusanInfoHandler(serverLocalName, officeInfo.value)}
                  optionsMap={photoInstallOptionsMap}
                  originalData={photoCustomerData}
                  reCall={getList}
                />
              )}
              <PhotoInfoCardComponent
                section='meterRead'
                headTitle='설치 정보'
                list={photoMeterReadInfo}
              />
            </div>

            {/* 2) 사진 정보 + 메인 이미지 + 썸네일 */}
            {photoCustomerData.existsInstallPhoto ? (
              <div className='flex-1 flex flex-col border rounded-md overflow-hidden max-h-[85vh] p-4'>
                {/* 메인 이미지 */}
                <div className='w-full pt-4'>
                  <p className='text-center text-[3rem] font-medium text-gray-700'>
                    사진 정보 : {photoList[selectedIndex]?.label}
                  </p>
                </div>
                <div className='flex justify-center items-center w-full flex-1'>
                  <div className='flex w-[50vh] h-[40vh] justify-center items-center'>
                    {photoList[selectedIndex]?.url === 'NULL' ||
                    photoList[selectedIndex]?.url === null ? (
                      <div className='max-w-full w-[200px] h-auto object-contain text-gray-500 '>
                        NO IMAGE
                      </div>
                    ) : (
                      <img
                        onClick={() => {
                          if (photoList[selectedIndex]?.label === '설치영상') {
                            return null
                          }
                          setIsZoomOpen(true)
                        }}
                        src={`${envImagePath}/install${photoList[selectedIndex]?.url}`}
                        alt='selected'
                        className={`transition duration-300 hover:contrast-[1.15]       
                       ${
                         photoList[selectedIndex]?.label === '설치영상'
                           ? 'aspect-[20/9] '
                           : 'h-auto cursor-zoom-in'
                       }`}
                      />
                    )}
                  </div>
                </div>

                {/* 썸네일 영역 */}
                <div className='flex gap-2 overflow-x-auto w-full py-2 px-1'>
                  {photoList?.map((photo: any, idx: number) => (
                    <div
                      key={idx}
                      ref={(el) => (thumbnailRefs.current[idx] = el)}
                      className='relative flex flex-col items-center w-full min-w-[80px]'
                    >
                      {/* 체크박스 */}
                      {photo?.url !== 'NULL' && photo?.url !== null && photo.check === true && (
                        <input
                          type='checkbox'
                          checked={selectedPhotoType.includes(photo.id)}
                          onChange={(e) => {
                            const isChecked = e.target.checked
                            setSelectedPhotoType((prev: any[]) =>
                              isChecked ? [...prev, photo.id] : prev.filter((id) => id !== photo.id)
                            )
                          }}
                          className='absolute top-2 left-2 z-10 w-6 h-6 accent-indigo-500'
                        />
                      )}
                      {photo?.url === 'NULL' || photo?.url === null ? (
                        <div
                          className={`w-full aspect-square flex items-center justify-center border text-gray-500 cursor-pointer transition 
    ${selectedIndex === idx ? 'ring-4 ring-blue-500' : ''}`}
                          onClick={() => setSelectedIndex(idx)}
                        >
                          NO IMAGE
                        </div>
                      ) : (
                        <img
                          src={`${envImagePath}/install${photo?.url}`}
                          alt={`photo-${idx}`}
                          className={`w-full l aspect-square object-cover border cursor-pointer transition 
          ${selectedIndex === idx ? 'ring-4 ring-blue-500' : ''}`}
                          onClick={() => setSelectedIndex(idx)}
                        />
                      )}
                      <span className='text-[18px] text-center mt-1 break-words'>
                        {photo.label}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className='flex flex-1 flex-col  border rounded-md items-center justify-center text-gray-400 max-h-[85vh] py-4'>
                <BrokenImageIcon fontSize='large' />
                <p className='mt-2 text-lg'>사진첩 이미지가 없습니다.</p>
              </div>
            )}
          </div>
        </Box>
        {isZoomOpen && (
          <div
            className='fixed inset-0 bg-black/80 z-[9999] flex items-center justify-center'
            onClick={() => setIsZoomOpen(false)}
          >
            <img
              src={`${envImagePath}/install${photoList[selectedIndex]?.url}`}
              alt='zoomed'
              className='max-w-[90vw] max-h-[90vh] object-contain cursor-zoom-out lg:scale-[1.2]'
            />
          </div>
        )}
      </>
    </Modal>
  )
}
export default PhotoModal
